import { render, staticRenderFns } from "./ShareMask.vue?vue&type=template&id=d9964588&scoped=true&"
import script from "./ShareMask.vue?vue&type=script&lang=js&"
export * from "./ShareMask.vue?vue&type=script&lang=js&"
import style0 from "./ShareMask.vue?vue&type=style&index=0&id=d9964588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9964588",
  null
  
)

export default component.exports